'use client';
/** @jsxImportSource @emotion/react */

import type { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';

import MuiTooltip from '@mui/material/Tooltip';

type ExcludedMuiProps =
  // Animation
  | 'disableInteractive'
  | 'TransitionComponent'
  // A11y fails if enabled
  | 'TransitionProps';

interface TooltipProps extends Omit<MuiTooltipProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { TooltipProps };
const Tooltip: React.FC<TooltipProps> = MuiTooltip;

Tooltip.displayName = 'Tooltip';
export { Tooltip };
